import { useState, useEffect } from "react";
import "./WazKBToolbar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { KB_MENUS, selectCurrentCollectionId, selectEditingCollection, selectUIStates, setUIStates } from "../../../redux/features/appData";

type WazKBToolbarProps = {

}

export const WazKBToolbar = ({} : WazKBToolbarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const uiStates = useSelector(selectUIStates)
    const collectionId = useSelector(selectEditingCollection)?.id
    
    // console.log("[WazKBToolbar] collectionId: ", collectionId);
    // console.log("[WazKBToolbar] uiStates.kbSelectedMenu: ", uiStates.kbSelectedMenu);

    return (
        <div className="waz-kb-toolbar">
            <div className="waz-kb-toolbar-section">
                Knowledge Base
            </div>

            <div 
                key={KB_MENUS.ACTIVITY}
                className={uiStates.kbSelectedMenu === KB_MENUS.ACTIVITY ? "waz-kb-toolbar-item-selected" : "waz-kb-toolbar-item"}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ACTIVITY}));
                    navigate("/waz/kb/activity")
                
                }}
            >
                Activity
            </div>

            <div 
                key={KB_MENUS.ADD}
                className={uiStates.kbSelectedMenu === KB_MENUS.ADD ? "waz-kb-toolbar-item-selected" : "waz-kb-toolbar-item"}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ADD}));
                    navigate("/waz/kb/add")
                }}
            >
                Add Resources
            </div>

            <div 
                key={KB_MENUS.MANAGE}
                className={uiStates.kbSelectedMenu === KB_MENUS.MANAGE ? "waz-kb-toolbar-item-selected" : "waz-kb-toolbar-item"}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.MANAGE}));
                    navigate("/waz/kb/manage/")
                }}
            >
                Manage Resources
            </div>

            <div 
                key={KB_MENUS.PERSONAS}
                className={uiStates.kbSelectedMenu === KB_MENUS.PERSONAS ? "waz-kb-toolbar-item-selected" : "waz-kb-toolbar-item"}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.PERSONAS}));
                    navigate("/waz/kb/personas/")
                }}
            >
                Personas
            </div>

            <div 
                key={KB_MENUS.ANALYTICS}
                className={uiStates.kbSelectedMenu === KB_MENUS.ANALYTICS ? "waz-kb-toolbar-item-selected" : "waz-kb-toolbar-item"}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ANALYTICS}));
                    navigate("/waz/kb/analytics/")
                }}
            >
                Analytics
            </div>

            {/* <div className="waz-kb-toolbar-section">
                Documents
            </div> */}

            {/* <div 
                className="waz-kb-toolbar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.DOCUMENTS}));
                    navigate("/waz/kb/documents");
                }}
            >
                Documents
            </div> */}
           
        </div>
    )
}